import { useEffect, useState } from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import {
  TeamGetParams,
  TeamGetResponse,
} from '../services/teamsService/getTeams'
import { teamsService } from '../services/teamsService'
import { useToast } from '@/view/components/ui/use-toast'
import { useAuth } from './useAuth'
import { useParams } from 'react-router-dom'

export const useTeams = () => {
  const [params, setParams] = useState<TeamGetParams>({ sort: 'transactions_total', order: '-1' })
  const { user } = useAuth()
  const { id } = useParams()

  const handleTeamsData = ({ pageParam = 0 }) => {
    if (id)
      return teamsService.getTeamsBySupervisorIds({
        ...params,
        skip: pageParam,
        supervisorIds: id,
      })

    return teamsService.getTeams({
      ...params,
      skip: pageParam,
    })
  }

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    isError,
  } = useInfiniteQuery({
    queryKey: ['Allteams', params, user?._id, id],
    queryFn: handleTeamsData,
    getNextPageParam: (lastPage: TeamGetResponse) => {
      const { skip, limit, total } = lastPage.pagination
      if (skip + limit >= total) return null
      if (lastPage.teams.length === 0) return null
      return skip + limit
    },
    initialPageParam: 0,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}
